export default "__VITE_ASSET__e5463a5d__"